// import React, { useState, useEffect } from 'react';
// import {
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Radio,
//   RadioGroup,
//   FormHelperText,
//   FormControlLabel,
//   FormLabel,
//   Checkbox,
//   Button,
//   Switch,
//   Grid,
//   Box,
//   Typography,
//   Paper,
//   AppBar,
//   Toolbar,
//   OutlinedInput,
// } from '@mui/material';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import InputAdornment from '@mui/material/InputAdornment';
// import IconButton from '@mui/material/IconButton';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useParams } from 'react-router-dom';
// import PhoneIcon from '@mui/icons-material/Phone';
// // import ReactFlagsSelect from "react-flags-select";
// // import CountryJson from '../../../utils/CountryCodes.json';
// import { isValidEmail, isValidPhoneNumber } from '../../../utils/helper.jsx';
// import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
// import { EntityFormFields } from '../../../interfaces/Entity.interface.ts';
// import { EntityActions } from '../../../Services/_actions/Entity/entity.actions.ts';
// import ClearIcon from '@mui/icons-material/Clear';
// import { ConstantActions } from '../../../Services/_actions/constant.actions.js';
// import ContentPasteIcon from '@mui/icons-material/ContentPaste';
// import {
//   BLOCKED_EXTENSIONS,
//   WHATSAPP_ALLOWED_MIME,
//   WHATSAPP_LIMITS,
// } from '../../Whatsapp/Template/template.constant.js';

// const CreateEditFormData = () => {
//   const { entityFormId } = useParams();
//   const { uuid } = useParams();
//   const actions = EntityActions();
//   const constantActions = ConstantActions();
//   const { state } = useLocation();
//   const [entityRowData, setEntityRowData] = useState<any>({});
//   // const [selectedParentEntity, setSelectedParentEntity] = useState < any > (null);
//   // const [nestedEntityDataDropdown, setNestedEntityDataDropdown] = useState < any > ([]);
//   const [selectedNestedParentEntity, setSelectedNestedParentEntity] = useState<any>({});
//   const [formData, setFormData] = useState<(EntityFormFields | any)[]>([]);
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();
//   const { showSnackBar } = useSnackBar();
//   const [errors, setErrors] = useState({});
//   const handleClickShowPassword = () => setShowPassword(!showPassword);
//   const [showHideFileUpload, setShowHideFileUpload] = useState({});
//   const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.preventDefault();
//   };

//   const validateFormData = (data: any) => {
//     let validationErrors: any = {};
//     data?.map((item: any) => {
//       switch (item?.type) {
//         case 'email':
//           if (item?.type === 'email' && isValidEmail(item?.value)) {
//             delete validationErrors[item?.name];
//           } else {
//             validationErrors[item?.name] = 'Please Enter a valid Email';
//           }
//           break;
//         case 'phone':
//           if (isValidPhoneNumber(item?.value)) {
//             delete validationErrors[item?.name];
//           } else {
//             validationErrors[item?.name] = 'Please Enter a valid Number';
//           }
//           break;
//       }
//     });
//     setErrors(validationErrors);
//     return validationErrors;
//   };
//   const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
//     if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
//     if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
//     if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
//     if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
//     return null;
//   };
//   const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);
//   const fileHelperTextMap: Record<string, string> = {
//     image: 'Allowed: JPG, PNG • Max 5 MB',
//     video: 'Allowed: MP4, MOV • Max 50 MB',
//     document: 'Allowed: PDF, DOCX • Max 10 MB',
//   };
//   const handleChange = (event: any, index: any, field: any) => {
//     const { name, value, type, checked, files, images } = event.target;
//     switch (field?.type) {
//       case 'text':
//       case 'textArea':
//       case 'number':
//       case 'email':
//       case 'dropdown':
//       case 'radio':
//       case 'date':
//       case 'password':
//         setFormData((prevItems: any) => {
//           const updatedItems = [...prevItems];
//           updatedItems[index] = { ...updatedItems[index], value: value };
//           return updatedItems;
//         });
//         break;
//       case 'phone':
//         let isInteger = Number.isInteger(Number(value));
//         if (isInteger && value.length < 13) {
//           setFormData((prevItems: any) => {
//             const updatedItems = [...prevItems];
//             updatedItems[index] = { ...updatedItems[index], value: value };
//             return updatedItems;
//           });
//           let obj: any = { ...errors };
//           delete obj[field?.name];
//           setErrors(obj);
//         } else if (value.length < 13) {
//           let obj: any = { ...errors };
//           obj[field?.name] = 'Please Enter a valid number';
//           setErrors(obj);
//         }
//         break;
//       case 'checkbox':
//         if (checked) {
//           setFormData((prevItems: any) => {
//             const updatedItems = [...prevItems];
//             updatedItems[index] = {
//               ...updatedItems[index],
//               value: [...(updatedItems[index]?.value || []), value],
//             };
//             return updatedItems;
//           });
//         } else {
//           setFormData((prevItems: any) => {
//             const updatedItems = [...prevItems];
//             const updateValue = updatedItems[index]['value']?.filter((item: any) => item !== value);
//             updatedItems[index] = { ...updatedItems[index], value: updateValue };
//             return updatedItems;
//           });
//         }
//         break;
//       // case 'file':
//       case 'image':
//       case 'video':
//       case 'document':
//         if (files && files[0]) {
//           const file = files[0];
//           if (!file) return;
//           const fileName = file?.name?.toLowerCase();
//           const ext = fileName.split('.').pop();
//           if (BLOCKED_EXTENSIONS.has(ext)) {
//             showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
//             event.target.value = '';
//             return;
//           }
//           const typeGroup = inferDocType(file.type);
//           if (!typeGroup) {
//             showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
//             event.target.value = '';
//             return;
//           }

//           const limit = WHATSAPP_LIMITS[typeGroup];
//           if (file.size > limit) {
//             showSnackBar(
//               `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file?.size)} MB.`,
//               'error'
//             );
//             event.target.value = '';
//             return;
//           }
//           const allowedExtensions: { [key: string]: string[] } = {
//             // file: ["pdf", "doc", "docx", "txt", "xls", "xlsx"],
//             image: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
//             video: [
//               'mp4',
//               'mov',
//               'avi',
//               'wmv',
//               'flv',
//               'mkv',
//               'webm',
//               'ogg',
//               'quicktime',
//               'msvideo',
//               'x-ms-wmv',
//               'x-ms-wmv',
//             ],
//             document: ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'],
//           };

//           const fileExtension = file?.name?.split('.').pop()?.toLowerCase();
//           if (fileExtension && allowedExtensions[field.type]?.includes(fileExtension)) {
//             setFormData((prevItems: any) => {
//               const updatedItems = [...prevItems];
//               updatedItems[index] = {
//                 ...updatedItems[index],
//                 value: file.name,
//                 fileObj: file,
//                 // newFile: true,
//               };
//               return updatedItems;
//             });
//           } else {
//             showSnackBar(
//               `Invalid file type for ${field.type}. Allowed: ${allowedExtensions[field.type].join(', ')}`,
//               'error'
//             );
//             event.target.value = null;
//             let obj: any = { ...errors };
//             obj[field?.name] =
//               `Invalid ${field.type} file type. Allowed: ${allowedExtensions[field.type].join(', ')}`;
//             setErrors(obj);
//           }
//         } else {
//           setFormData((prevItems: any) => {
//             const updatedItems = [...prevItems];
//             updatedItems[index] = { ...updatedItems[index], value: value };
//             return updatedItems;
//           });
//         }
//     }
//   };

//   const entityId: any = uuid !== 'create' ? state?.row?._id : null;

//   const uploadFile = async (file: File): Promise<{ link?: string; name?: string }> => {
//     try {
//       if (file) {
//         // const myFilename = `${Date.now().toString()}_${file.name.replace(/ /g, '_')}`;
//         // const updatedFile = new File([file], myFilename, { type: file.type });
//         const formData = new FormData();
//         formData.append('file', file);
//         const resp = await constantActions.uploadFileS3Bucket(formData);
//         if (resp?.status === 200 && resp?.data?.data) {
//           return { link: resp?.data?.data?.url ?? '', name: resp?.data?.data?.filename ?? '' };
//         }
//         // if (resp?.$response?.httpResponse?.statusCode === 200) {
//         //   const link = `${process.env.REACT_APP_IMAGE_URL}/${myFilename}`;
//         //   return { link: link, name: myFilename };
//         // }
//       }
//     } catch (error) {
//       console.error('File upload failed:', error);
//     }
//     return { link: '', name: '' };
//   };

//   const handleSubmit = async (event: React.FormEvent) => {
//     event.preventDefault();
//     const error = validateFormData(formData);
//     if (Object.keys(error).length > 0) return;
//     // const currentEntity = selectedNestedParentEntity[entityRowData?.parentEntityForm?._id] ?? null;
//     const payload: Record<string, any> = {
//       // entity_form: entityRowData?.entity_form || entityFormId,
//       entity_form_id: entityFormId,
//       // parentEntity: { _id: currentEntity?._id },
//       entity: {},
//     };

//     const toPhoneInt = (val: any): number | undefined => {
//       const digits = String(val ?? '').replace(/\D+/g, '');
//       return digits ? Number(digits) : undefined;
//     };

//     try {
//       for (const item of formData) {
//         if (['image', 'video', 'document'].includes(item.type)) {
//           if (item.fileObj) {
//             const obj: any = await uploadFile(item.fileObj);
//             payload.entity[item.name] = obj?.link ?? ''; //{ type: item.type, url: obj?.link, name: obj?.name || '' };
//           } else if (item.value) {
//             payload.entity[item.name] = item.value ?? '';
//           } else if (entityRowData?.entity?.[item.name]) {
//             payload.entity[item.name] = entityRowData?.entity?.[item.name] || {};
//           } else {
//             delete payload.entity[item.name];
//           }
//         } else if (item.type === 'phone') {
//           const n = toPhoneInt(item.value);
//           payload.entity[item.name] = n !== undefined ? n : '';
//         } else {
//           payload.entity[item.name] = item.value || '';
//         }
//       }

//       const res =
//         uuid === 'create'
//           ? await actions.createEntity(payload)
//           : await actions.updateDetails(entityId, payload);

//       if (res?.status === 200) {
//         showSnackBar(
//           `Entity ${uuid === 'create' ? 'Created' : 'Updated'} successfully!`,
//           'success'
//         );
//         navigate(-1);
//       } else {
//         showSnackBar('Error!', 'error');
//       }
//     } catch (error) {
//       showSnackBar('Error!', 'error');
//     }
//   };

//   // Fetches the main entity form by ID
//   const getEntityFormById = async () => {
//     try {
//       let res = await actions.getFormById(entityFormId);
//       if (res?.status === 200 && res?.data?.items) {
//         setEntityRowData(res?.data?.items);
//         const fields = res?.data?.items?.form_fields ?? [];
//         // fetchAllParentEntitiesForm(res.data.items[0]);
//         if (uuid === 'create') {
//           setFormData(fields);
//           return;
//         } else {
//           const populatedFields = fields.map((field) => ({
//             ...field,
//             value: state?.row?.entity?.[field.name] ?? '',
//           }));
//           setFormData(populatedFields);
//         }
//       }
//     } catch (error) {
//       console.warn(error);
//     }
//   };

//   // const fetchAllParentEntitiesForm = async (entityFormObj: any) => {
//   //     const parents: any[] = [];
//   //     let current = entityFormObj;
//   //     while (current?.parentEntityForm?._id) {
//   //         try {
//   //             const parentRes = await actions.getFormById(current.parentEntityForm._id);
//   //             if (parentRes?.status === 200 && parentRes?.data?.items?.length) {
//   //                 const parentItem = parentRes.data.items[0];
//   //                 parents.push(parentItem);
//   //                 current = parentItem;
//   //             } else {
//   //                 break;
//   //             }
//   //         } catch (err) {
//   //             console.warn("Error fetching parent entity form:", err);
//   //             break;
//   //         }
//   //     }
//   //     setNestedEntityDataDropdown(parents.reverse());
//   // };
//   // const fetchAllParentEntityData = async (entityDataObj) => {
//   //     let entityData = {};
//   //     let current = entityDataObj;
//   //     while (current?.parentEntity?._id) {
//   //         try {
//   //             const parentRes = await actions.getEntityDataById(current?.parentEntity?._id);
//   //             if (parentRes && parentRes?.data?.data && parentRes?.status === 200) {
//   //                 entityData = { ...entityData, [parentRes?.data?.data?.entity_form_id]: parentRes?.data?.data };
//   //                 const parentItem = parentRes?.data?.data;
//   //                 current = parentItem;
//   //             } else {
//   //                 break;
//   //             }
//   //         } catch (err) {
//   //             console.warn("Error fetching parent entity form:", err);
//   //             break;
//   //         }
//   //     }
//   //     setSelectedNestedParentEntity(entityData);
//   // };

//   // const getChildEntityIds = (parentId) => {
//   //     let children = [];

//   //     const traverse = (currentParentId) => {
//   //         nestedEntityDataDropdown.forEach((form) => {
//   //             if (form?.parentEntityForm?._id === currentParentId) {
//   //                 children.push(form._id);
//   //                 traverse(form._id); // recursive call to go deeper
//   //             }
//   //         });
//   //     };

//   //     traverse(parentId);
//   //     return [...new Set(children)]; // unique IDs
//   // };
//   // const handleSelectEntityData = (value, entityFormId) => {
//   //     setSelectedNestedParentEntity((prev) => {
//   //         const updated = {
//   //             ...prev,
//   //             [entityFormId]: value?._id ? { _id: value?._id, entity: value?.entity } : null,
//   //         };
//   //         const childrenToRemove = getChildEntityIds(entityFormId);
//   //         childrenToRemove.forEach((childId) => {
//   //             delete updated[childId];
//   //         });
//   //         return updated;
//   //     });
//   // };

//   useEffect(() => {
//     const loadFormData = async () => {
//       getEntityFormById();
//       // if (state?.row) {
//       //     fetchAllParentEntityData(state?.row)
//       // }
//     };
//     loadFormData();
//   }, [uuid, state?.row]);

//   const getFileNameFromUrl = (url) => {
//     try {
//       const fileName = url?.split('/')?.pop() ?? '';
//       return fileName;
//     } catch (err) {
//       return '';
//     }
//   };
//   return (
//     <Box sx={{ width: '100%', minHeight: '90vh', backgroundColor: '#fff', padding: '15px' }}>
//       <Box sx={{ flexGrow: 1, marginBottom: '10px' }}>
//         <AppBar
//           sx={{ backgroundColor: 'transparent', color: 'grey', boxShadow: 'none !important' }}
//           position="static"
//         >
//           <Toolbar>
//             <Typography color="Black" variant="h6" component="div" sx={{ flexGrow: 1 }}>
//               {entityRowData?.name || ''} Form
//             </Typography>
//             <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//               <Button onClick={() => navigate(-1)} size="small" variant="contained" color="primary">
//                 Back
//               </Button>
//             </Box>
//           </Toolbar>
//         </AppBar>
//       </Box>
//       <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: '2px' }}>
//         {/* {nestedEntityDataDropdown?.length > 0 && nestedEntityDataDropdown?.map((item: any, index: number) => (
//                     <EntityDetailsDropdown
//                         key={index}
//                         label={`Select ${item?.name} `}
//                         entityFormId={item?._id ?? null}
//                         parentEntityId={selectedNestedParentEntity[item?.parentEntityForm?._id]?._id ?? null}
//                         selectedEntityFields={[]}
//                         displayField={item?.form_fields?.find((field: any) => field.isDefaultDisplay)?.name}
//                         value={selectedNestedParentEntity[item?._id] ?? null}
//                         onChange={(value: any) => {
//                             handleSelectEntityData(value, item?._id);
//                         }}
//                         sx={{ mb: 2, width: '100%' }}
//                     />
//                 ))} */}
//         {Object?.keys(formData)?.length > 0 && (
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ '& .MuiTextField-root': { mb: 3, width: '100%' } }}
//           >
//             {formData?.map((field: any, index: Number) => {
//               if (uuid === 'create' && index === 0) return null;
//               const shouldDisable = uuid !== 'create' && index === 0;

//               switch (field.type) {
//                 case 'text':
//                 case 'number':
//                 case 'email':
//                   return (
//                     <TextField
//                       key={field?.name}
//                       name={field?.name || 'Text'}
//                       label={field?.label || 'Input'}
//                       type={field?.type}
//                       placeholder={field?.placeholder || ''}
//                       value={field?.value || ''}
//                       onChange={(e: any) => {
//                         handleChange(e, index, field);
//                       }}
//                       required={field?.isRequired}
//                       error={errors[field?.name]}
//                       helperText={errors[field?.name] ? errors[field?.name] : ''}
//                       variant="outlined"
//                       disabled={shouldDisable}
//                       fullWidth
//                       sx={{ mb: 2 }}
//                       size="small"
//                     />
//                   );
//                 case 'phone':
//                   return (
//                     <>
//                       <Grid container spacing={2} alignItems="center">
//                         <Grid item xs={12} sm={12}>
//                           <TextField
//                             key={field?.name}
//                             label="Phone Number"
//                             placeholder={field?.placeholder || ''}
//                             value={field?.value}
//                             onChange={(e: any) => {
//                               handleChange(e, index, field);
//                             }}
//                             error={errors[field?.name]}
//                             helperText={errors[field?.name] ? errors[field?.name] : ''}
//                             InputProps={{
//                               startAdornment: (
//                                 <InputAdornment position="start">
//                                   <PhoneIcon />
//                                 </InputAdornment>
//                               ),
//                             }}
//                             required={field?.isRequired}
//                             variant="outlined"
//                             fullWidth
//                             sx={{ mb: 2 }}
//                             size="small"
//                           />
//                         </Grid>
//                       </Grid>
//                     </>
//                   );

//                 case 'textArea':
//                   return (
//                     <>
//                       <TextField
//                         id={`text-area${field?.name}`}
//                         name={field?.name || 'TextArea'}
//                         label={field?.label || 'Input'}
//                         placeholder={field?.placeholder || ''}
//                         multiline
//                         rows={3}
//                         value={field?.value || ''}
//                         onChange={(e: any) => {
//                           handleChange(e, index, field);
//                         }}
//                         required={field?.isRequired}
//                         variant="outlined"
//                         fullWidth
//                         size="small"
//                         InputProps={{
//                           inputProps: {
//                             minLength: 0, // Minimum length constraint
//                             // maxLength: 500,
//                           },
//                         }}
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-root': {
//                             padding: 0,
//                           },
//                           '& textarea': {
//                             resize: 'both', // right-bottom resize handle
//                             overflow: 'auto',
//                           },
//                         }}
//                         // sx={{ mb: 2 }}
//                       />
//                       {/* <FormHelperText>Max length 2000.</FormHelperText> */}
//                     </>
//                   );
//                 case 'password':
//                   return (
//                     <FormControl
//                       key={field.name}
//                       required={field?.isRequired}
//                       variant="outlined"
//                       sx={{ mb: 2, width: '100%' }}
//                     >
//                       <InputLabel htmlFor="outlined-adornment-password">
//                         {field?.label || 'Password'}
//                       </InputLabel>
//                       <OutlinedInput
//                         id={`${field.name}-outlined-adornment-password`}
//                         type={showPassword ? 'text' : 'password'}
//                         value={field?.value || ''}
//                         onChange={(e: any) => {
//                           handleChange(e, index, field);
//                         }}
//                         placeholder={field?.placeholder || ''}
//                         label={field?.label || 'Password'}
//                         size="small"
//                         endAdornment={
//                           <InputAdornment position="end">
//                             <IconButton
//                               aria-label="toggle password visibility"
//                               onClick={handleClickShowPassword}
//                               onMouseDown={handleMouseDownPassword}
//                               edge="end"
//                             >
//                               {showPassword ? <VisibilityOff /> : <Visibility />}
//                             </IconButton>
//                           </InputAdornment>
//                         }
//                       />
//                     </FormControl>
//                   );
//                 case 'dropdown':
//                   return (
//                     <FormControl key={field.name} variant="outlined" sx={{ mb: 2, width: '100%' }}>
//                       <InputLabel id={`${field?.name}-label`}>
//                         {field.label}
//                         {field?.isRequired && ' *'}
//                       </InputLabel>
//                       <Select
//                         labelId={`${field?.name}-label`}
//                         id={`${field?.name}-label`}
//                         name={field?.name}
//                         value={field?.value}
//                         onChange={(e: any) => {
//                           handleChange(e, index, field);
//                         }}
//                         label={`${field.label}${field?.isRequired ? ' *' : ''}`}
//                         required={field?.isRequired}
//                         size="small"
//                       >
//                         {field?.options?.map((option: any) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   );
//                 case 'radio':
//                   return (
//                     <FormControl key={field.name} variant="outlined" sx={{ mb: 2, width: '100%' }}>
//                       <FormLabel component="legend">
//                         {field?.label}
//                         {field?.isRequired && ' *'}
//                       </FormLabel>
//                       <RadioGroup
//                         name={field?.name}
//                         value={field?.value || ''}
//                         onChange={(e: any) => {
//                           handleChange(e, index, field);
//                         }}
//                         row
//                       >
//                         {field?.options?.map((option: any) => (
//                           <FormControlLabel
//                             key={option}
//                             value={option}
//                             control={<Radio required={field?.isRequired} />}
//                             label={option}
//                           />
//                         ))}
//                       </RadioGroup>
//                     </FormControl>
//                   );
//                 case 'checkbox':
//                   return (
//                     <FormControl
//                       key={field?.name}
//                       required={field?.isRequired}
//                       variant="outlined"
//                       sx={{ mb: 2, width: '100%' }}
//                     >
//                       <FormLabel component="legend">{field?.label}</FormLabel>
//                       {field?.options?.map((option: any) => (
//                         <FormControlLabel
//                           key={option}
//                           control={
//                             <Checkbox
//                               name={field?.name}
//                               value={option}
//                               checked={field?.value?.includes(option)}
//                               onChange={(e: any) => {
//                                 handleChange(e, index, field);
//                               }}
//                             />
//                           }
//                           label={option}
//                         />
//                       ))}
//                       {field?.isRequired && (
//                         <FormHelperText>Please select at least one option.</FormHelperText>
//                       )}
//                     </FormControl>
//                   );
//                 case 'date':
//                   return (
//                     <>
//                       <TextField
//                         key={field?.name}
//                         id={field?.name}
//                         name={field?.name || 'Date'}
//                         label={field?.label || 'Select'}
//                         type={'date'}
//                         placeholder={field?.placeholder || 'Select Date'}
//                         value={field?.value}
//                         onChange={(e: any) => {
//                           handleChange(e, index, field);
//                         }}
//                         // onClick={(event: any) => { event.target.value = null }}
//                         required={field?.isRequired}
//                         variant="outlined"
//                         fullWidth
//                         size="small"
//                         sx={{ mb: 2 }}
//                         InputLabelProps={{
//                           shrink: true,
//                         }}
//                       />
//                     </>
//                   );
//                 case 'image':
//                 case 'document':
//                 case 'video':
//                   return (
//                     <Box key={field?.name} sx={{ mb: 2 }}>
//                       {/* <Typography variant="body2">
//                       {field.label} {field?.isRequired && '*'}
//                     </Typography> */}
//                       <FormControlLabel
//                         control={
//                           <Switch
//                             checked={showHideFileUpload[field?.name] ?? false}
//                             onChange={(e) => {
//                               setShowHideFileUpload((prevItems: any) => {
//                                 const updatedItems = { ...prevItems };
//                                 updatedItems[field?.name] = e.target.checked;
//                                 return updatedItems;
//                               });
//                             }}
//                             inputProps={{ 'aria-label': 'controlled' }}
//                             size="small"
//                           />
//                         }
//                         label={`Upload ${field?.type ?? ''}`}
//                       />
//                       {/* File preview if exists */}
//                       {!showHideFileUpload[field?.name] && (
//                         <TextField
//                           id={`${field?.name}-link`}
//                           name={`${field?.name}-link`}
//                           type="url"
//                           label={`Paste a direct ${field?.type ?? ''} link`}
//                           value={field?.value ?? ''}
//                           onChange={(e: any) => handleChange(e, index, field)}
//                           variant="outlined"
//                           fullWidth
//                           size="small"
//                           sx={{ mt: 1 }}
//                           required={field?.isRequired ?? false}
//                           InputProps={{
//                             endAdornment: (
//                               <IconButton
//                                 edge="end"
//                                 onClick={async () => {
//                                   try {
//                                     const url = await navigator.clipboard.readText();
//                                     const fileName = url?.split('/')?.pop() ?? '';
//                                     setFormData((prevItems: any) => {
//                                       const updatedItems = [...prevItems];
//                                       updatedItems[index] = {
//                                         ...updatedItems[index],
//                                         fileObj: null,
//                                         value: url ?? '', //{ type: field?.type, url: text, name: fileName },
//                                       };
//                                       return updatedItems;
//                                     });
//                                   } catch (err) {
//                                     console.error('Clipboard read failed', err);
//                                   }
//                                 }}
//                               >
//                                 <ContentPasteIcon />
//                               </IconButton>
//                             ),
//                           }}
//                         />
//                       )}

//                       {showHideFileUpload[field?.name] && (
//                         <>
//                           {field?.value && field?.value && (
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
//                               <Typography variant="body2" color="primary">
//                                 <a
//                                   href={field?.value ?? ''}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                 >
//                                   {getFileNameFromUrl(field?.value) ?? ''}
//                                 </a>
//                               </Typography>
//                               <IconButton
//                                 size="small"
//                                 onClick={() => {
//                                   setFormData((prevItems: any) => {
//                                     const updatedItems = [...prevItems];
//                                     updatedItems[index] = {
//                                       ...updatedItems[index],
//                                       fileObj: null,
//                                       value: '',
//                                     };
//                                     return updatedItems;
//                                   });

//                                   setErrors((prevErrors) => {
//                                     const newErrors = { ...prevErrors };
//                                     delete newErrors[field?.name];
//                                     return newErrors;
//                                   });
//                                 }}
//                               >
//                                 <ClearIcon fontSize="small" color="black" />
//                               </IconButton>
//                             </Box>
//                           )}
//                           <TextField
//                             id={`${field?.name}-file`}
//                             name={`${field?.name}-file`}
//                             type="file"
//                             onChange={(e: any) => handleChange(e, index, field, 'file')}
//                             variant="outlined"
//                             fullWidth
//                             size="small"
//                             required={field?.isRequired ?? false}
//                             error={!!errors[field?.name]}
//                             helperText={errors[field?.name] ? errors[field?.name] : ''}
//                             InputLabelProps={{ shrink: true }}
//                           />
//                         </>
//                       )}
//                       <FormHelperText sx={{ mt: 0 }}>
//                         {fileHelperTextMap[field?.type ?? ''] ?? ''}
//                       </FormHelperText>
//                     </Box>
//                   );
//                 default:
//                   return null;
//               }
//             })}
//             <Button
//               type="submit"
//               size="small"
//               variant="contained"
//               color="primary"
//               sx={{ width: '100%' }}
//             >
//               Submit
//             </Button>
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default CreateEditFormData;

import React, { useState, useEffect, useMemo } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  Checkbox,
  Button,
  Switch,
  Grid,
  Box,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  OutlinedInput,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardContent,
  Divider,
  Chip,
  Avatar,
  LinearProgress,
  Alert,
  Snackbar,
  Tooltip,
  Fade,
  Grow,
  Zoom,
  Slide,
  Stack,
  Badge,
  IconButton as MuiIconButton,
  Container,
  useTheme,
  alpha,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { isValidEmail, isValidPhoneNumber } from '../../../utils/helper.jsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { EntityFormFields } from '../../../interfaces/Entity.interface.ts';
import { EntityActions } from '../../../Services/_actions/Entity/entity.actions.ts';
import ClearIcon from '@mui/icons-material/Clear';
import { ConstantActions } from '../../../Services/_actions/constant.actions.js';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import {
  BLOCKED_EXTENSIONS,
  WHATSAPP_ALLOWED_MIME,
  WHATSAPP_LIMITS,
} from '../../Whatsapp/Template/template.constant.js';

// ─── Styled Components ──────────────────────────────────────────────────────────

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: 16,
  background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
  boxShadow: '0 8px 32px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
  border: '1px solid rgba(0,0,0,0.04)',
}));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  boxShadow: 'none !important',
  padding: theme.spacing(1, 0),
}));

const FormSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2.5),
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  border: '1px solid rgba(0,0,0,0.06)',
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: 'rgba(25,118,210,0.15)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
  },
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(2.5),
  paddingBottom: theme.spacing(1),
  borderBottom: '2px solid #f0f0f0',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: '#fafafa',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&.Mui-focused': {
      backgroundColor: '#ffffff',
      boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.12)}`,
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    fontSize: '0.8125rem',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main,
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: 8,
  backgroundColor: '#fafafa',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  '&.Mui-focused': {
    backgroundColor: '#ffffff',
    boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.12)}`,
  },
}));

const DropZone = styled(Box)(({ theme }) => ({
  border: '2px dashed rgba(0,0,0,0.12)',
  borderRadius: 12,
  padding: theme.spacing(2.5),
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: '#fafafa',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
  '&.dragging': {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    transform: 'scale(1.01)',
  },
}));

const FilePreviewCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  borderRadius: 8,
  backgroundColor: '#f5f5f5',
  border: '1px solid rgba(0,0,0,0.06)',
  marginTop: theme.spacing(1),
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  borderRadius: 10,
  padding: theme.spacing(1.5, 4),
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 4px 12px rgba(25,118,210,0.25)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(25,118,210,0.35)',
  },
  '&:active': {
    transform: 'translateY(0px)',
  },
}));

const FieldLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.8125rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
}));

const RequiredStar = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
  marginLeft: 2,
}));

const CompactFieldWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  '&:last-child': {
    marginBottom: 0,
  },
}));

// ─── Main Component ──────────────────────────────────────────────────────────

const CreateEditFormData = () => {
  const { entityFormId } = useParams();
  const { uuid } = useParams();
  const actions = EntityActions();
  const constantActions = ConstantActions();
  const { state } = useLocation();
  const theme = useTheme();
  const [entityRowData, setEntityRowData] = useState<any>({});
  const [selectedNestedParentEntity, setSelectedNestedParentEntity] = useState<any>({});
  const [formData, setFormData] = useState<(EntityFormFields | any)[]>([]);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { showSnackBar } = useSnackBar();
  const [errors, setErrors] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showHideFileUpload, setShowHideFileUpload] = useState({});

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  // ─── Helper Functions ──────────────────────────────────────────────────────

  // Check if a field is an auto-generated ID field
  const isAutoGeneratedIdField = (field: any) => {
    const idPatterns = ['_id', 'id', 'uuid', 'guid', 'identifier', 'autoId', 'generatedId'];
    const name = field?.name?.toLowerCase() || '';
    const label = field?.label?.toLowerCase() || '';
    
    return (
      idPatterns.some(pattern => name === pattern || name.includes(pattern)) ||
      idPatterns.some(pattern => label === pattern || label.includes(pattern)) ||
      field?.autoGenerated === true ||
      field?.isPrimaryKey === true ||
      field?.readOnly === true
    );
  };

  // Check if a field should be hidden in the form
  const shouldHideField = (field: any, index: number) => {
    // Hide the first field if it's an ID field
    if (uuid === 'create' && index === 0) {
      const firstField = formData[0];
      if (firstField && isAutoGeneratedIdField(firstField)) {
        return true;
      }
    }
    
    // Hide if it's an auto-generated ID field
    if (isAutoGeneratedIdField(field)) {
      return true;
    }
    
    // Hide if it's explicitly marked as hidden
    if (field?.hidden === true) {
      return true;
    }
    
    // Hide if it's a system field
    if (field?.systemField === true) {
      return true;
    }
    
    return false;
  };

  // Check if a field should be disabled (read-only)
  const shouldDisableField = (field: any, index: number) => {
    // Disable if it's a system field in edit mode
    if (uuid !== 'create' && isAutoGeneratedIdField(field)) {
      return true;
    }
    
    // Disable if it's marked as read-only
    if (field?.readOnly === true) {
      return true;
    }
    
    return false;
  };

  // ─── Validation ─────────────────────────────────────────────────────────────

  const validateFormData = (data: any) => {
    let validationErrors: any = {};
    data?.map((item: any) => {
      // Skip validation for hidden fields
      if (shouldHideField(item, 0)) return;
      
      if (item.isRequired && !item.value) {
        validationErrors[item.name] = `${item.label || 'This field'} is required`;
      }
      switch (item?.type) {
        case 'email':
          if (item?.value && !isValidEmail(item?.value)) {
            validationErrors[item?.name] = 'Please enter a valid email address';
          }
          break;
        case 'phone':
          if (item?.value && !isValidPhoneNumber(item?.value)) {
            validationErrors[item?.name] = 'Please enter a valid phone number';
          }
          break;
      }
    });
    setErrors(validationErrors);
    return validationErrors;
  };

  // ─── File Helpers ──────────────────────────────────────────────────────────

  const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
    if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
    if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
    if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
    if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
    return null;
  };

  const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);

  const fileHelperTextMap: Record<string, string> = {
    image: 'JPG, PNG, GIF, WebP • Max 5 MB',
    video: 'MP4, MOV, AVI, WebM • Max 50 MB',
    document: 'PDF, DOC, DOCX, TXT • Max 10 MB',
  };

  const fileIconMap: Record<string, any> = {
    image: <ImageIcon sx={{ color: '#4CAF50' }} />,
    video: <VideoFileIcon sx={{ color: '#FF5722' }} />,
    document: <PictureAsPdfIcon sx={{ color: '#F44336' }} />,
    file: <InsertDriveFileIcon sx={{ color: '#2196F3' }} />,
  };

  const getFileIcon = (type: string) => fileIconMap[type] || <InsertDriveFileIcon />;

  // ─── Handle Change ─────────────────────────────────────────────────────────

  const handleChange = (event: any, index: any, field: any) => {
    const { name, value, type, checked, files } = event.target;

    switch (field?.type) {
      case 'text':
      case 'textArea':
      case 'number':
      case 'email':
      case 'dropdown':
      case 'radio':
      case 'date':
      case 'password':
        setFormData((prevItems: any) => {
          const updatedItems = [...prevItems];
          updatedItems[index] = { ...updatedItems[index], value: value };
          return updatedItems;
        });
        // Clear error on change
        if (errors[field?.name]) {
          setErrors((prev: any) => {
            const newErrors = { ...prev };
            delete newErrors[field?.name];
            return newErrors;
          });
        }
        break;

      case 'phone':
        let isInteger = Number.isInteger(Number(value));
        if (isInteger && value.length < 13) {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            updatedItems[index] = { ...updatedItems[index], value: value };
            return updatedItems;
          });
          let obj: any = { ...errors };
          delete obj[field?.name];
          setErrors(obj);
        } else if (value.length < 13) {
          let obj: any = { ...errors };
          obj[field?.name] = 'Please enter a valid number';
          setErrors(obj);
        }
        break;

      case 'checkbox':
        if (checked) {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            updatedItems[index] = {
              ...updatedItems[index],
              value: [...(updatedItems[index]?.value || []), value],
            };
            return updatedItems;
          });
        } else {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            const updateValue = updatedItems[index]['value']?.filter((item: any) => item !== value);
            updatedItems[index] = { ...updatedItems[index], value: updateValue };
            return updatedItems;
          });
        }
        break;

      case 'image':
      case 'video':
      case 'document':
        if (files && files[0]) {
          const file = files[0];
          if (!file) return;
          const fileName = file?.name?.toLowerCase();
          const ext = fileName.split('.').pop();
          if (BLOCKED_EXTENSIONS.has(ext)) {
            showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
            event.target.value = '';
            return;
          }
          const typeGroup = inferDocType(file.type);
          if (!typeGroup) {
            showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
            event.target.value = '';
            return;
          }

          const limit = WHATSAPP_LIMITS[typeGroup];
          if (file.size > limit) {
            showSnackBar(
              `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file?.size)} MB.`,
              'error'
            );
            event.target.value = '';
            return;
          }

          const allowedExtensions: { [key: string]: string[] } = {
            image: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
            video: ['mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm', 'ogg'],
            document: ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'],
          };

          const fileExtension = file?.name?.split('.').pop()?.toLowerCase();
          if (fileExtension && allowedExtensions[field.type]?.includes(fileExtension)) {
            setFormData((prevItems: any) => {
              const updatedItems = [...prevItems];
              updatedItems[index] = {
                ...updatedItems[index],
                value: file.name,
                fileObj: file,
              };
              return updatedItems;
            });
          } else {
            showSnackBar(
              `Invalid file type for ${field.type}. Allowed: ${allowedExtensions[field.type].join(', ')}`,
              'error'
            );
            event.target.value = null;
            let obj: any = { ...errors };
            obj[field?.name] =
              `Invalid ${field.type} file type. Allowed: ${allowedExtensions[field.type].join(', ')}`;
            setErrors(obj);
          }
        }
        break;
    }
  };

  // ─── Upload File ──────────────────────────────────────────────────────────

  const uploadFile = async (file: File): Promise<{ link?: string; name?: string }> => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        const resp = await constantActions.uploadFileS3Bucket(formData);
        if (resp?.status === 200 && resp?.data?.data) {
          return { link: resp?.data?.data?.url ?? '', name: resp?.data?.data?.filename ?? '' };
        }
      }
    } catch (error) {
      console.error('File upload failed:', error);
      showSnackBar('File upload failed. Please try again.', 'error');
    }
    return { link: '', name: '' };
  };

  // ─── Submit ────────────────────────────────────────────────────────────────

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    
    // Filter out hidden fields before validation
    const visibleFields = formData.filter((field, index) => !shouldHideField(field, index));
    const error = validateFormData(visibleFields);
    if (Object.keys(error).length > 0) {
      showSnackBar('Please fix all errors before submitting', 'error');
      return;
    }

    setIsSubmitting(true);

    const payload: Record<string, any> = {
      entity_form_id: entityFormId,
      entity: {},
    };

    const toPhoneInt = (val: any): number | undefined => {
      const digits = String(val ?? '').replace(/\D+/g, '');
      return digits ? Number(digits) : undefined;
    };

    try {
      for (const item of formData) {
        // Skip hidden fields
        if (shouldHideField(item, 0)) continue;
        
        if (['image', 'video', 'document'].includes(item.type)) {
          if (item.fileObj) {
            const obj: any = await uploadFile(item.fileObj);
            payload.entity[item.name] = obj?.link ?? '';
          } else if (item.value) {
            payload.entity[item.name] = item.value ?? '';
          } else if (entityRowData?.entity?.[item.name]) {
            payload.entity[item.name] = entityRowData?.entity?.[item.name] || {};
          } else {
            delete payload.entity[item.name];
          }
        } else if (item.type === 'phone') {
          const n = toPhoneInt(item.value);
          payload.entity[item.name] = n !== undefined ? n : '';
        } else {
          payload.entity[item.name] = item.value || '';
        }
      }

      const res =
        uuid === 'create'
          ? await actions.createEntity(payload)
          : await actions.updateDetails(entityId, payload);

      if (res?.status === 200) {
        showSnackBar(
          `Entity ${uuid === 'create' ? 'Created' : 'Updated'} successfully!`,
          'success'
        );
        setTimeout(() => navigate(-1), 1500);
      } else {
        showSnackBar('Error saving entity. Please try again.', 'error');
      }
    } catch (error) {
      console.error('Submit error:', error);
      showSnackBar('An unexpected error occurred. Please try again.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  // ─── Fetch Form Data ──────────────────────────────────────────────────────

  const entityId: any = uuid !== 'create' ? state?.row?._id : null;

  const getEntityFormById = async () => {
    try {
      let res = await actions.getFormById(entityFormId);
      if (res?.status === 200 && res?.data?.items) {
        setEntityRowData(res?.data?.items);
        const fields = res?.data?.items?.form_fields ?? [];
        if (uuid === 'create') {
          // Filter out auto-generated ID fields for new forms
          const filteredFields = fields.filter((field, index) => !shouldHideField(field, index));
          setFormData(filteredFields);
        } else {
          const populatedFields = fields.map((field) => ({
            ...field,
            value: state?.row?.entity?.[field.name] ?? '',
          }));
          // Filter out auto-generated ID fields for edit forms
          const filteredFields = populatedFields.filter((field, index) => !shouldHideField(field, index));
          setFormData(filteredFields);
        }
      }
    } catch (error) {
      console.warn(error);
      showSnackBar('Error loading form data', 'error');
    }
  };

  useEffect(() => {
    getEntityFormById();
  }, [uuid, state?.row]);

  const getFileNameFromUrl = (url) => {
    try {
      const fileName = url?.split('/')?.pop() ?? '';
      return fileName || 'Uploaded file';
    } catch (err) {
      return 'Uploaded file';
    }
  };

  // ─── Get Field Icon ──────────────────────────────────────────────────────

  const getFieldIcon = (type: string) => {
    switch (type) {
      case 'text':
        return <PersonIcon sx={{ fontSize: 20, color: '#1976D2' }} />;
      case 'email':
        return <EmailIcon sx={{ fontSize: 20, color: '#1976D2' }} />;
      case 'phone':
        return <PhoneIcon sx={{ fontSize: 20, color: '#1976D2' }} />;
      case 'textArea':
        return <DescriptionIcon sx={{ fontSize: 20, color: '#1976D2' }} />;
      case 'date':
        return <CalendarTodayIcon sx={{ fontSize: 20, color: '#1976D2' }} />;
      default:
        return null;
    }
  };

  // ─── Get Field Type Color ────────────────────────────────────────────────

  const getFieldColor = (type: string) => {
    switch (type) {
      case 'email':
        return '#1976D2';
      case 'phone':
        return '#2E7D32';
      case 'password':
        return '#D32F2F';
      case 'date':
        return '#E65100';
      case 'textArea':
        return '#7B1FA2';
      case 'image':
        return '#4CAF50';
      case 'video':
        return '#FF5722';
      case 'document':
        return '#F44336';
      default:
        return '#1976D2';
    }
  };

  // ─── Get Field Size for Grid ─────────────────────────────────────────────

  const getFieldGridSize = (field: any) => {
    const type = field?.type || 'text';
    const label = field?.label || '';
    const name = field?.name || '';

    // Large fields that should take full width
    if (type === 'textArea' || type === 'description' || type === 'message') {
      return { xs: 12, sm: 12, md: 12 };
    }

    // Medium fields
    if (type === 'email' || type === 'phone' || type === 'password') {
      return { xs: 12, sm: 6, md: 6 };
    }

    // Check if field name suggests a large content field
    const largeContentKeywords = ['description', 'message', 'notes', 'comments', 'content', 'body'];
    if (largeContentKeywords.some(keyword => name.toLowerCase().includes(keyword) || label.toLowerCase().includes(keyword))) {
      return { xs: 12, sm: 12, md: 12 };
    }

    // Check if field name suggests a short field
    const shortFieldKeywords = ['name', 'title', 'code', 'short', 'initial'];
    if (shortFieldKeywords.some(keyword => name.toLowerCase().includes(keyword) || label.toLowerCase().includes(keyword))) {
      return { xs: 12, sm: 4, md: 3 };
    }

    // Default to half width
    return { xs: 12, sm: 6, md: 6 };
  };

  // ─── Render Form Field ────────────────────────────────────────────────────

  const renderField = (field: any, index: number) => {
    // Skip hidden fields
    if (shouldHideField(field, index)) return null;
    
    const isDisabled = shouldDisableField(field, index);

    const commonProps = {
      required: field?.isRequired && !isDisabled,
      error: !!errors[field?.name],
      helperText: errors[field?.name] || '',
      variant: 'outlined' as const,
      fullWidth: true,
      size: 'small' as const,
    };

    switch (field.type) {
      case 'text':
      case 'number':
      case 'email':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                {getFieldIcon(field.type)}
                {field?.label || 'Input'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
                {isDisabled && (
                  <Chip
                    label="Read-only"
                    size="small"
                    sx={{ fontSize: '0.55rem', height: 16, ml: 0.5 }}
                  />
                )}
              </FieldLabel>
              <StyledTextField
                name={field?.name}
                type={field?.type}
                placeholder={field?.placeholder || ''}
                value={field?.value || ''}
                onChange={(e: any) => handleChange(e, index, field)}
                disabled={isDisabled}
                {...commonProps}
                InputProps={{
                  startAdornment: field.type === 'email' && (
                    <InputAdornment position="start">
                      <EmailIcon sx={{ color: '#9e9e9e', fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiInputBase-root': {
                    backgroundColor: isDisabled ? '#f5f5f5' : '#fafafa',
                  },
                }}
              />
            </CompactFieldWrapper>
          </Grow>
        );

      case 'phone':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                <PhoneIcon sx={{ fontSize: 20, color: '#2E7D32' }} />
                {field?.label || 'Phone Number'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <StyledTextField
                label=""
                placeholder={field?.placeholder || 'Enter phone number'}
                value={field?.value || ''}
                onChange={(e: any) => handleChange(e, index, field)}
                disabled={isDisabled}
                {...commonProps}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon sx={{ color: '#2E7D32' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </CompactFieldWrapper>
          </Grow>
        );

      case 'textArea':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                <DescriptionIcon sx={{ fontSize: 20, color: '#7B1FA2' }} />
                {field?.label || 'Description'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <StyledTextField
                name={field?.name}
                placeholder={field?.placeholder || ''}
                multiline
                rows={3}
                value={field?.value || ''}
                onChange={(e: any) => handleChange(e, index, field)}
                disabled={isDisabled}
                {...commonProps}
                sx={{
                  '& .MuiInputBase-root': {
                    padding: 0,
                    backgroundColor: isDisabled ? '#f5f5f5' : '#fafafa',
                  },
                  '& textarea': {
                    resize: 'vertical',
                    padding: '10px 14px',
                  },
                }}
              />
            </CompactFieldWrapper>
          </Grow>
        );

      case 'password':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                <VpnKeyIcon sx={{ fontSize: 20, color: '#D32F2F' }} />
                {field?.label || 'Password'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <FormControl variant="outlined" fullWidth size="small">
                <OutlinedInput
                  type={showPassword ? 'text' : 'password'}
                  value={field?.value || ''}
                  onChange={(e: any) => handleChange(e, index, field)}
                  placeholder={field?.placeholder || ''}
                  disabled={isDisabled}
                  size="small"
                  sx={{
                    borderRadius: 2,
                    backgroundColor: isDisabled ? '#f5f5f5' : '#fafafa',
                    '&:hover': { backgroundColor: isDisabled ? '#f5f5f5' : '#f5f5f5' },
                    '&.Mui-focused': {
                      backgroundColor: isDisabled ? '#f5f5f5' : '#ffffff',
                      boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.12)}`,
                    },
                  }}
                  endAdornment={
                    !isDisabled && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }
                />
                {errors[field?.name] && (
                  <FormHelperText error>{errors[field?.name]}</FormHelperText>
                )}
              </FormControl>
            </CompactFieldWrapper>
          </Grow>
        );

      case 'dropdown':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                {field?.label || 'Select an option'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <FormControl fullWidth size="small" error={!!errors[field?.name]}>
                <StyledSelect
                  value={field?.value || ''}
                  onChange={(e: any) => handleChange(e, index, field)}
                  disabled={isDisabled}
                  displayEmpty
                  renderValue={(selected: any) => {
                    if (!selected) {
                      return <Typography color="textSecondary">Select an option</Typography>;
                    }
                    return selected;
                  }}
                  sx={{ 
                    borderRadius: 2, 
                    backgroundColor: isDisabled ? '#f5f5f5' : '#fafafa' 
                  }}
                >
                  <MenuItem value="" disabled>
                    <Typography color="textSecondary">Select an option</Typography>
                  </MenuItem>
                  {field?.options?.map((option: any) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </StyledSelect>
                {errors[field?.name] && (
                  <FormHelperText error>{errors[field?.name]}</FormHelperText>
                )}
              </FormControl>
            </CompactFieldWrapper>
          </Grow>
        );

      case 'radio':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                {field?.label || 'Select an option'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <RadioGroup
                name={field?.name}
                value={field?.value || ''}
                onChange={(e: any) => handleChange(e, index, field)}
                sx={{ mt: 0.5 }}
              >
                <Stack direction="row" spacing={2} flexWrap="wrap">
                  {field?.options?.map((option: any) => (
                    <FormControlLabel
                      key={option}
                      value={option}
                      control={<Radio size="small" disabled={isDisabled} />}
                      label={option}
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: '0.8125rem',
                        },
                      }}
                    />
                  ))}
                </Stack>
              </RadioGroup>
              {errors[field?.name] && (
                <FormHelperText error>{errors[field?.name]}</FormHelperText>
              )}
            </CompactFieldWrapper>
          </Grow>
        );

      case 'checkbox':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                {field?.label || 'Select options'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                {field?.options?.map((option: any) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        name={field?.name}
                        value={option}
                        checked={field?.value?.includes(option)}
                        onChange={(e: any) => handleChange(e, index, field)}
                        disabled={isDisabled}
                        size="small"
                      />
                    }
                    label={option}
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: '0.8125rem',
                      },
                    }}
                  />
                ))}
              </Stack>
              {errors[field?.name] && (
                <FormHelperText error>{errors[field?.name]}</FormHelperText>
              )}
            </CompactFieldWrapper>
          </Grow>
        );

      case 'date':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                <CalendarTodayIcon sx={{ fontSize: 20, color: '#E65100' }} />
                {field?.label || 'Date'}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>
              <StyledTextField
                type="date"
                value={field?.value || ''}
                onChange={(e: any) => handleChange(e, index, field)}
                disabled={isDisabled}
                {...commonProps}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& input': {
                    padding: '8px 14px',
                    backgroundColor: isDisabled ? '#f5f5f5' : '#fafafa',
                  },
                }}
              />
            </CompactFieldWrapper>
          </Grow>
        );

      case 'image':
      case 'document':
      case 'video':
        return (
          <Grow in timeout={300} key={field?.name || index}>
            <CompactFieldWrapper>
              <FieldLabel>
                {getFileIcon(field.type)}
                {field?.label || `Upload ${field?.type}`}
                {field?.isRequired && !isDisabled && <RequiredStar>*</RequiredStar>}
              </FieldLabel>

              {!isDisabled && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={showHideFileUpload[field?.name] ?? false}
                      onChange={(e) => {
                        setShowHideFileUpload((prevItems: any) => ({
                          ...prevItems,
                          [field?.name]: e.target.checked,
                        }));
                      }}
                      size="small"
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                          color: theme.palette.primary.main,
                        },
                      }}
                    />
                  }
                  label={<Typography variant="caption">Upload from device</Typography>}
                />
              )}

              {!showHideFileUpload[field?.name] && (
                <StyledTextField
                  type="url"
                  label="Paste file URL"
                  value={field?.value || ''}
                  onChange={(e: any) => handleChange(e, index, field)}
                  disabled={isDisabled}
                  {...commonProps}
                  sx={{ mt: 0.5 }}
                  InputProps={{
                    endAdornment: !isDisabled && (
                      <InputAdornment position="end">
                        <Tooltip title="Paste from clipboard">
                          <IconButton
                            edge="end"
                            size="small"
                            onClick={async () => {
                              try {
                                const url = await navigator.clipboard.readText();
                                setFormData((prevItems: any) => {
                                  const updatedItems = [...prevItems];
                                  updatedItems[index] = {
                                    ...updatedItems[index],
                                    fileObj: null,
                                    value: url,
                                  };
                                  return updatedItems;
                                });
                                showSnackBar('URL pasted from clipboard', 'success');
                              } catch (err) {
                                console.error('Clipboard read failed', err);
                                showSnackBar('Unable to read clipboard', 'error');
                              }
                            }}
                          >
                            <ContentPasteIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              )}

              {showHideFileUpload[field?.name] && !isDisabled && (
                <Box sx={{ mt: 0.5 }}>
                  {field?.value && (
                    <FilePreviewCard>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                        {getFileIcon(field.type)}
                        <Typography variant="body2" sx={{ flex: 1, wordBreak: 'break-all' }}>
                          <a
                            href={field?.value}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: theme.palette.primary.main, textDecoration: 'none' }}
                          >
                            {getFileNameFromUrl(field?.value)}
                          </a>
                        </Typography>
                      </Box>
                      <Tooltip title="Remove file">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setFormData((prevItems: any) => {
                              const updatedItems = [...prevItems];
                              updatedItems[index] = {
                                ...updatedItems[index],
                                fileObj: null,
                                value: '',
                              };
                              return updatedItems;
                            });
                            setErrors((prevErrors) => {
                              const newErrors = { ...prevErrors };
                              delete newErrors[field?.name];
                              return newErrors;
                            });
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </FilePreviewCard>
                  )}

                  <DropZone
                    onClick={() => {
                      const input = document.getElementById(`${field?.name}-file-input`);
                      if (input) input.click();
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add('dragging');
                    }}
                    onDragLeave={(e) => {
                      e.currentTarget.classList.remove('dragging');
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove('dragging');
                      const files = e.dataTransfer.files;
                      if (files.length) {
                        const event = { target: { files } };
                        handleChange(event, index, field);
                      }
                    }}
                  >
                    <CloudUploadIcon sx={{ fontSize: 40, color: '#9e9e9e', mb: 0.5 }} />
                    <Typography variant="body2" color="textSecondary">
                      Drag & drop or click to upload
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {fileHelperTextMap[field?.type] || ''}
                    </Typography>
                    <input
                      id={`${field?.name}-file-input`}
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(e: any) => handleChange(e, index, field)}
                      accept={
                        field.type === 'image'
                          ? 'image/*'
                          : field.type === 'video'
                            ? 'video/*'
                            : field.type === 'document'
                              ? '.pdf,.doc,.docx,.txt,.xls,.xlsx'
                              : '*'
                      }
                    />
                  </DropZone>
                  {errors[field?.name] && (
                    <Alert severity="error" sx={{ mt: 1, '& .MuiAlert-message': { fontSize: '0.75rem' } }}>
                      {errors[field?.name]}
                    </Alert>
                  )}
                </Box>
              )}
              
              {isDisabled && field?.value && (
                <FilePreviewCard>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                    {getFileIcon(field.type)}
                    <Typography variant="body2" sx={{ flex: 1, wordBreak: 'break-all' }}>
                      <a
                        href={field?.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: theme.palette.primary.main, textDecoration: 'none' }}
                      >
                        {getFileNameFromUrl(field?.value)}
                      </a>
                    </Typography>
                  </Box>
                  <Chip label="Read-only" size="small" sx={{ fontSize: '0.55rem', height: 16 }} />
                </FilePreviewCard>
              )}
            </CompactFieldWrapper>
          </Grow>
        );

      default:
        return null;
    }
  };

  // ─── Group Fields into Sections ──────────────────────────────────────────

  const getFieldSections = useMemo(() => {
    const sections: any = {};
    let visibleFieldsCount = 0;
    
    formData.forEach((field, index) => {
      if (shouldHideField(field, index)) return;
      
      visibleFieldsCount++;
      const section = field.section || 'General Information';
      if (!sections[section]) {
        sections[section] = [];
      }
      sections[section].push({ ...field, index });
    });
    
    return { sections, totalVisible: visibleFieldsCount };
  }, [formData]);

  const { sections: fieldSections, totalVisible: totalVisibleFields } = getFieldSections;
  const sectionKeys = Object.keys(fieldSections);
  
  // Calculate progress based on visible fields only
  const filledFields = formData.filter((f, i) => {
    if (shouldHideField(f, i)) return false;
    return f.value;
  }).length;
  
  const progress = totalVisibleFields > 0 ? (filledFields / totalVisibleFields) * 100 : 0;

  // ─── Render ──────────────────────────────────────────────────────────────────

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: '#f5f7fa', py: 2 }}>
      <Container maxWidth="lg">
        {/* ── Header ── */}
        <StyledAppBar position="static">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <IconButton onClick={() => navigate(-1)} size="small">
                <ArrowBackIcon />
              </IconButton>
              <Box>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {entityRowData?.name || 'Entity'} Form
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {uuid === 'create' ? 'Create new entry' : 'Edit existing entry'}
                  {totalVisibleFields > 0 && ` • ${totalVisibleFields} field${totalVisibleFields > 1 ? 's' : ''}`}
                </Typography>
              </Box>
              <Chip
                label={uuid === 'create' ? 'New' : 'Edit'}
                size="small"
                color={uuid === 'create' ? 'success' : 'warning'}
                sx={{ fontWeight: 500, fontSize: '0.7rem' }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => navigate(-1)}
                sx={{ textTransform: 'none', borderRadius: 2, px: 2 }}
              >
                Cancel
              </Button>
              <SubmitButton
                size="small"
                type="submit"
                variant="contained"
                disabled={isSubmitting}
                startIcon={isSubmitting ? null : <SaveIcon />}
                onClick={handleSubmit}
                sx={{ textTransform: 'none', borderRadius: 2, px: 3 }}
              >
                {isSubmitting ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LinearProgress size={18} sx={{ width: 18, height: 18, color: 'white' }} />
                    Saving...
                  </Box>
                ) : (
                  `${uuid === 'create' ? 'Create' : 'Update'}`
                )}
              </SubmitButton>
            </Box>
          </Toolbar>
        </StyledAppBar>

        {/* ── Progress Bar ── */}
        {totalVisibleFields > 0 && (
          <Card sx={{ mb: 2, p: 1.5, borderRadius: 2, border: '1px solid rgba(0,0,0,0.06)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
              <Typography variant="body2" fontWeight={500} fontSize="0.8125rem">
                Form Progress
              </Typography>
              <Typography variant="body2" color="textSecondary" fontSize="0.75rem">
                {filledFields} / {totalVisibleFields} fields filled
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={Math.min(progress, 100)}
              sx={{
                height: 4,
                borderRadius: 3,
                backgroundColor: 'rgba(0,0,0,0.06)',
                '& .MuiLinearProgress-bar': {
                  borderRadius: 3,
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                },
              }}
            />
          </Card>
        )}

        {/* ── Form ── */}
        <StyledPaper>
          <form onSubmit={handleSubmit}>
            {sectionKeys.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="textSecondary">
                  No fields available for this form
                </Typography>
              </Box>
            ) : (
              sectionKeys.map((sectionName, sectionIndex) => {
                const sectionFields = fieldSections[sectionName];
                return (
                  <FormSection key={sectionIndex}>
                    <SectionHeader>
                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,
                          bgcolor: alpha(theme.palette.primary.main, 0.1),
                          color: theme.palette.primary.main,
                          fontSize: '0.75rem',
                          fontWeight: 600,
                        }}
                      >
                        {sectionIndex + 1}
                      </Avatar>
                      <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                        {sectionName}
                      </Typography>
                      <Box sx={{ flex: 1 }} />
                      <Chip
                        label={`${sectionFields.length} field${sectionFields.length > 1 ? 's' : ''}`}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '0.6rem', height: 20 }}
                      />
                    </SectionHeader>

                    <Grid container spacing={2}>
                      {sectionFields.map(({ ...field }) => {
                        const gridSize = getFieldGridSize(field);
                        return (
                          <Grid
                            item
                            xs={gridSize.xs}
                            sm={gridSize.sm}
                            md={gridSize.md}
                            key={field.name || field.index}
                          >
                            {renderField(field, field.index)}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </FormSection>
                );
              })
            )}

            {/* ── Submit Section ── */}
            {totalVisibleFields > 0 && (
              <Box
                sx={{
                  mt: 3,
                  pt: 2.5,
                  borderTop: '2px solid #f0f0f0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 1.5,
                }}
              >
                <Box>
                  {Object.keys(errors).length > 0 && (
                    <Chip
                      icon={<ErrorIcon sx={{ fontSize: 16 }} />}
                      label={`${Object.keys(errors).length} error${Object.keys(errors).length > 1 ? 's' : ''} to fix`}
                      size="small"
                      color="error"
                      sx={{ fontSize: '0.75rem' }}
                    />
                  )}
                  {Object.keys(errors).length === 0 && filledFields > 0 && (
                    <Chip
                      icon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
                      label="All fields valid"
                      size="small"
                      color="success"
                      sx={{ fontSize: '0.75rem' }}
                    />
                  )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1.5 }}>
                  <Button
                    variant="outlined"
                    onClick={() => navigate(-1)}
                    sx={{ textTransform: 'none', borderRadius: 2, px: 3 }}
                    size="small"
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting || totalVisibleFields === 0}
                    startIcon={isSubmitting ? null : <SaveIcon />}
                    size="small"
                  >
                    {isSubmitting ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LinearProgress size={18} sx={{ width: 18, height: 18, color: 'white' }} />
                        Saving...
                      </Box>
                    ) : (
                      `${uuid === 'create' ? 'Create' : 'Update'}`
                    )}
                  </SubmitButton>
                </Box>
              </Box>
            )}
          </form>
        </StyledPaper>

        {/* ── Footer ── */}
        {totalVisibleFields > 0 && (
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Typography variant="caption" color="textSecondary" fontSize="0.7rem">
              All fields marked with <RequiredStar>*</RequiredStar> are required
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default CreateEditFormData;